export default __webpack_public_path__ + "static/media/logo_white.f09861dd.svg";